import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  column-gap: ${(props) => (props.gap ? props.gap + "px" : "24px")};
  row-gap: ${(props) => (props.gap ? props.gap + "px" : "48px")};
  height: ${(props) => (props.height ? props.height + "px" : "100%")};
  width: ${(props) => (props.width ? props.width + "px" : "100%")};
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : "0px")};
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : "0px")};
  padding-right: ${(props) =>
    props.paddingRight ? props.paddingRight : "0px"};
  padding-bottom: ${(props) =>
    props.paddingBottom ? props.paddingBottom : "0px"};
  justify-content: center;
`;

export default Grid;
